import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateWatermark, setCanvasSize } from '@modules/editor';
import WatermarkCanvas from './WatermarkCanvas';

function WatermarkCanvasContainer() {
    const dispatch = useDispatch();
    const watermarkList = useSelector((state: any) => state.editor.watermarkList);
    const vodInfo = useSelector((state: any) => state.media.vodInfo);
    const canvasSize = useSelector((state: any) => state.editor.canvasSize);

    const syncWithVideo = () => {
        const videoEl = document.querySelector('.vjs-text-track-display');
        if (videoEl && vodInfo) {
            const rect = videoEl.getBoundingClientRect();
            const [width, height] = vodInfo.videoSize.split('x').map(Number);
            const aspectRatio = width / height;
            console.log('videoEl', rect.width, rect.width / aspectRatio);
            dispatch(setCanvasSize({
                canvasWidth: rect.width,
                canvasHeight: rect.width / aspectRatio
            }));
        }
    };

    // 컨테이너 클릭 시 모든 편집 모드 해제
    const handleContainerClick = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement;

        // 워터마크 요소를 클릭한 경우가 아니라면 모든 편집 모드 해제
        if (target === e.currentTarget) {
            watermarkList.forEach((watermark, index) => {
                if (watermark.isEditing) {
                    dispatch(updateWatermark({
                        ...watermark,
                        isEditing: false,
                        index: index
                    }));
                }
            });
        }
    };

    useEffect(() => {
        syncWithVideo();
        window.addEventListener('resize', syncWithVideo);
        window.addEventListener('scroll', syncWithVideo);
        return () => {
            window.removeEventListener('resize', syncWithVideo);
            window.removeEventListener('scroll', syncWithVideo);
        };
    }, []);

    return (
        <div
            className="container-watermarkCanvas"
            style={{
                width: `${canvasSize.canvasWidth}px`,
                height: `${canvasSize.canvasHeight}px`,
                position: 'absolute',
                zIndex: 997
            }}
            onClick={handleContainerClick}
        >
            {watermarkList.map((_, idx) => (
                <WatermarkCanvas key={idx} idx={idx} />
            ))}
        </div>
    );
}

export default WatermarkCanvasContainer;